// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__iXxYD","main":"layout_main__IspO1"};